import { Pipe, PipeTransform } from '@angular/core';

import { isNull } from 'lodash-es';

@Pipe({
  name: 'redRangeFilterText',
  standalone: false
})
export class RangeFilterTextPipe implements PipeTransform {
  transform(
    value: { lower: number; upper: number } | null,
    options: { labelDefault: string; labelPlural: string; labelSingular: string; max: number; min: number }
  ) {
    let result = '';
    if (!isNull(value)) {
      if (value.lower === options.min && value.upper === options.max) {
        result = options.labelDefault;
      } else if (value.lower === options.min && value.lower === value.upper) {
        result = `No ${options.labelPlural}`;
      } else if (value.upper === options.max) {
        result = `At least ${value.lower} ${value.lower > 1 ? options.labelPlural : options.labelSingular}`;
      } else if (value.lower === options.min && value.lower !== value.upper) {
        result = `Up to ${value.upper} ${value.lower > 1 ? options.labelPlural : options.labelSingular}`;
      } else {
        result = `${value.lower}-${value.upper} ${value.upper > 1 ? options.labelPlural : options.labelSingular}`;
      }
    }
    return result;
  }
}
